import { Person } from '@axo/shared/data-access/types/puzzel/Person';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const getPersonByS2ID =
  ({ url: { service: baseURL }, token }: IAPI) =>
  (s2ID: string): Promise<Person> =>
    send({
      baseURL,
      token,
      path: `/puzzel/s2/id/${encodeURIComponent(s2ID)}`,
      method: 'GET',
    });
